export default __webpack_public_path__ + "static/SR USA - Sobre alergenos - Declaración-0c7aac5bde6365082533a80d30ee7478.pdf";